import React from 'react';
import './style.css'
import { useTranslation } from 'react-i18next'; 

// Composant réutilisable pour la section d'inscription---
const InscriptionCard = ({
  imageSrc,
  title,
  description,
  bouton,
}: {
  imageSrc: string;
  title: string;
  description: string;
  bouton:string
}) => (

<div className="py-7 flex flex-col items-center justify-center h-[500px] w-[300px] md:h-[600px]  md:w-[400px] lg:h-[550px] lg:w-[450px] max-w-[550px] bg-blue-primary rounded-xl gap-5 px-6 transition-all duration-[2000ms] ease-in-out">
  <img
    src={imageSrc}
    alt={title}
    className="h-[80px] w-[80px] md:h-[100px] md:w-[100px] lg:h-[120px] lg:w-[90px]"
  />
  <h3 className="text-primary-green font-bold text-xl md:text-2xl lg:text-2xl">
    {title}
  </h3>
  <p className="text-white text-center font-light text-sm md:text-base lg:text-md">
    {description}
  </p>
  <button className="btn-anime rounded-lg bg-primary-green text-black py-2 px-6 md:py-3 md:px-8 text-sm md:text-lg lg:text-xl font-normal">
    {bouton}
  </button>
</div>




);

const Rejoindre = () => {

  const { t } = useTranslation();
  return (
    <div className=" px-2 md:px-6 md:container md:py-10 md:mx-auto ">
      <div className="flex items-center justify-center">
        <h1 className="text-[30px] text-blue-header  font-bold font-raleway md:text-4xl lg:text-3xl xl:text-5xl">{t('inscription.titreHero')}</h1>
      </div>

      <p className="mt-4 text-center">
      {t('inscription.text')}
      </p>

      <div className="flex flex-col gap-3 justify-center items-center px-4 md:px-15 md:container md:flex-row md:justify-center md:gap-10 py-5 lg:px-36 lg:container lg:flex-row lg:justify-center lg:gap-10 xl:40 ">
        <InscriptionCard
          imageSrc="/assets/images/vecteurs/stethoscope.svg"
          title={t('inscription.prestataire1')}
          description={t('inscription.doctorText')}
          bouton={t('inscription.bouton')}
        />
        <InscriptionCard
          imageSrc="/assets/images/vecteurs/pharmacy.svg"
          title="Pharmacies"
          description={t('inscription.pharmacieText')}
          bouton={t('inscription.bouton')}
        />
      </div>
    </div>
  );
};

export default Rejoindre;
